import { createFileRoute, Navigate } from "@tanstack/react-router";
export const Route = createFileRoute("/_authed/library")({ component: () => <Navigate to="/" replace /> });
